// @ts-nocheck
import * as queries from '../queries/openBehaviorsQueries';

export default function getMobilePanelProps(editorAPI) {
  const currentOpenBehaviors = queries.getCurrentOpenBehaviors(editorAPI);
  return {
    shouldOpenInMobile: queries.isOpenInMobile(currentOpenBehaviors, editorAPI),
  };
}
